import React from "react";
import styleBox from './OneItemBox.module.css'

const OneItemBox = ({ photo, name, label1, des1, label2, des2, label3 }) => {
    return (
        <>
                <p className={styleBox.forexp}>For Export</p>
                <p className={styleBox.meddev}>{label3}</p>  
            {/* <div className={styleBox.tag}>
            </div> */}
            <div className={styleBox.photo}><img src={photo}/></div>
            <div className={styleBox.item}>
                <div className={styleBox.name}>{name}</div>
                <div className={styleBox.container}>
                    <div className={styleBox.label}>{label1}</div>
                    <div className={styleBox.description}>{des1}</div>
                </div>
                <div className={styleBox.container}>
                    <div className={styleBox.label}>{label2}</div>
                    <div className={styleBox.description}>{des2}</div>
                </div>
            </div>
        </>
    );
};

export default OneItemBox;